/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { DeleteRequestDto } from '../models/DeleteRequestDto';
import type { InputName } from '../models/InputName';
import type { InputsResponseDto } from '../models/InputsResponseDto';
import type { ReplaceRequestDto } from '../models/ReplaceRequestDto';
import type { UpsertRequestDto } from '../models/UpsertRequestDto';

export class InputsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Post Preference Sets
   * Apply one atomic operation to the scope's input set.
   * @param requestBody
   * @returns InputsResponseDto Successful Response
   * @throws ApiError
   */
  public postPreferenceSetsDiscoveryV1InputsPreferenceSetsPost(
    requestBody: UpsertRequestDto | DeleteRequestDto | ReplaceRequestDto
  ): CancelablePromise<InputsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/discovery/v1/inputs/preference_sets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Preference Sets
   * Read inputs under `(employee_id, set_id)`, optionally filtered.
   * @param employeeId Owner identity
   * @param setId Preference-set partition
   * @param inputName Optional equality filter on input_name
   * @param subjectId Optional equality filter on subject_id. Omitted = no filter (NOT the employee — employee-only reads aren't expressible here)
   * @returns InputsResponseDto Successful Response
   * @throws ApiError
   */
  public getPreferenceSetsDiscoveryV1InputsPreferenceSetsGet(
    employeeId: string,
    setId: string,
    inputName?: InputName | null,
    subjectId?: string | null
  ): CancelablePromise<InputsResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/discovery/v1/inputs/preference_sets',
      query: {
        employee_id: employeeId,
        set_id: setId,
        input_name: inputName,
        subject_id: subjectId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Post Preference Sets
   * Apply one atomic operation to the scope's input set.
   * @param requestBody
   * @returns InputsResponseDto Successful Response
   * @throws ApiError
   */
  public postPreferenceSetsInternalDiscoveryEvaluationInputsPreferenceSetsPost(
    requestBody: UpsertRequestDto | DeleteRequestDto | ReplaceRequestDto
  ): CancelablePromise<InputsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/discovery/evaluation/inputs/preference_sets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Preference Sets
   * Read inputs under `(employee_id, set_id)`, optionally filtered.
   * @param employeeId Owner identity
   * @param setId Preference-set partition
   * @param inputName Optional equality filter on input_name
   * @param subjectId Optional equality filter on subject_id. Omitted = no filter (NOT the employee — employee-only reads aren't expressible here)
   * @returns InputsResponseDto Successful Response
   * @throws ApiError
   */
  public getPreferenceSetsInternalDiscoveryEvaluationInputsPreferenceSetsGet(
    employeeId: string,
    setId: string,
    inputName?: InputName | null,
    subjectId?: string | null
  ): CancelablePromise<InputsResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/discovery/evaluation/inputs/preference_sets',
      query: {
        employee_id: employeeId,
        set_id: setId,
        input_name: inputName,
        subject_id: subjectId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
